<div class="row flex-between-center border">
  <div class="col-auto my-2">
    <labeled-content [label]="'general.name'">
      <label class="data-labels">{{ specialEntityContact().name }}</label>
    </labeled-content>
  </div>
  <div class="col-auto my-2">
    <labeled-content [label]="'general.taxNumber'">
      <label class="data-labels">{{ specialEntityContact().taxNumber }}</label>
    </labeled-content>
  </div>
  <div class="col-auto my-2">
    <labeled-content [label]="'general.headquarters'">
      <div class="address-lines data-labels">
        <span>{{ specialEntityContact().country }}</span>
        <span>{{ specialEntityContact().address.zipCode }}</span>
        <span>{{ specialEntityContact().address.city }}</span>
        <span>{{ getAddress(specialEntityContact().address) }}</span>
      </div>
    </labeled-content>
  </div>
  <div class="col-auto my-2">
    <labeled-content [label]="'general.emailAddress'">
      <label class="data-labels">{{ specialEntityContact().email }}</label>
    </labeled-content>
  </div>
</div>
